/* eslint-disable @typescript-eslint/no-explicit-any */
var _a;
import { createStitches } from '../lib/stitches/react';
import { defaultMedia, defaultThemeMap, defaultTokens, defaultUtilities } from './tokens';
const _global = typeof globalThis === 'undefined' ? window : globalThis;
const stitches = createStitches({
    theme: defaultTokens,
    media: defaultMedia,
    themeMap: defaultThemeMap,
    utils: defaultUtilities,
    prefix: (_a = _global.STITCHES_PREFIX) !== null && _a !== void 0 ? _a : ''
});
// const {
//   css,
//   styled,
//   getCssText,
//   globalCss,
//   keyframes,
//   reset,
//   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//   // @ts-ignore
//   sheet: groupSheet,
//   createTheme: stitchesCreateTheme
// } = stitches;
// const createTheme = (name: string, theme: Theme) =>
//   stitchesCreateTheme(name, theme as any);
export { defaultBreakpoints, defaultColors, defaultGradients, defaultMedia, defaultMiscColors, defaultSpacing, defaultThemeMap, defaultTokens, defaultUtilities } from './tokens';
export const css = stitches.css;
export const styled = stitches.styled;
export const getCssText = stitches.getCssText;
export const createTheme = stitches.createTheme;
export const globalCss = stitches.globalCss;
export const keyframes = stitches.keyframes;
export const reset = stitches.reset;
export const groupSheet = stitches.sheet;
